import React from 'react';

import styles from './TodosBeforeSession.module.scss';

const TodosBeforeSession = ({
  heading,
  description,
  listComp,
}) => (
  <div className={styles.mainContainer}>
    <div className={styles.header}>To-Do Before the Session</div>
    <div className={styles.container}>
      <div className={styles.heading}>{heading}</div>
      <div className={styles.desc}>{description}</div>
      <div className={styles.list}>{listComp}</div>
    </div>
  </div>
);

export default TodosBeforeSession;
